<ion-item *ngFor="let item of items" (click)="itemClicked(item)" style="cursor:pointer;">
	<ion-label>{{ item.title || item.key }}</ion-label>
	<ion-icon [name]="item.icon" [color]="item.iconColor"></ion-icon>
</ion-item>